module.exports = __webpack_public_path__ + "images/emoji/school.fc08bcb416044c8cc8fc.png";